import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { DynIcon } from "@/components/site/Icon";
import { PublicLayout } from "@/components/site/PublicLayout";

export default function PracticeAreas() {
  const [areas, setAreas] = useState([]);
  useEffect(() => { api.get("/practice-areas").then((r) => setAreas(r.data)); }, []);
  useSeo({
    title: "Areas of Practice | Adv. Guruvayoorappan K V, Advocate Thrissur",
    description: "Legal services across civil, criminal, matrimonial, property, consumer, business and documentation matters in Thrissur and across Kerala.",
  });

  return (
    <PublicLayout>
      <section className="bg-navy py-14 lg:py-20" data-testid="practice-areas-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-brass font-mono text-xs tracking-[0.25em] uppercase mb-4">What We Handle</p>
          <h1 className="font-serif text-4xl lg:text-5xl text-ivory leading-tight mb-4">Areas of Practice</h1>
          <p className="text-ivory/60 max-w-2xl leading-relaxed">Adv. Guruvayoorappan K V provides representation, consultation and documentation services across a range of legal matters. Every matter is assessed on its facts, applicable law, jurisdiction and professional availability.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((a) => (
            <div key={a.id} className="group bg-white border border-slate-200 rounded-lg p-7 hover:border-brass hover:shadow-lg transition-all flex flex-col" data-testid={`practice-area-${a.slug}`}>
              <span className="w-12 h-12 rounded-sm bg-navy text-brass flex items-center justify-center mb-5 group-hover:bg-brass group-hover:text-navy transition-colors">
                <DynIcon name={a.icon} size={22} />
              </span>
              <h2 className="font-serif text-xl text-navy mb-3 leading-snug">{a.title}</h2>
              <p className="text-slate-500 text-sm leading-relaxed mb-4 flex-1">{a.short_desc}</p>
              {a.services?.length > 0 && (
                <ul className="text-sm text-slate-600 space-y-1 mb-5">
                  {a.services.slice(0, 4).map((s, i) => (
                    <li key={i} className="flex items-start gap-2"><span className="text-brass mt-1">·</span>{s}</li>
                  ))}
                </ul>
              )}
              <Link to={`/practice-areas/${a.slug}`} className="inline-flex items-center gap-1 text-brass font-medium text-sm group-hover:gap-2 transition-all mt-auto" data-testid={`practice-learn-${a.slug}`}>
                Learn More <ArrowRight size={14} />
              </Link>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
